import React from 'react';

interface TunesIconProps {
  width?: string;
  height?: string;
  primaryColor?: string;
  secondaryColor?: string;
}

const TunesIcon: React.FC<TunesIconProps> = ({
  width = '61',
  height = '60',
  primaryColor = '#1F1A6B',
  secondaryColor = '#FFFFFF',
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 61 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.336914" width={width} height={height} rx="4" fill={primaryColor} />
      <path
        d="M24.3663 21.6557V35.8375C23.7065 35.4563 22.9672 35.2339 22.2066 35.1878C21.4461 35.1417 20.6853 35.2732 19.9844 35.572C19.2835 35.8707 18.6617 36.3284 18.1682 36.9089C17.6747 37.4894 17.3231 38.1768 17.1411 38.9167C16.9592 39.6565 16.9519 40.4286 17.1198 41.1718C17.2877 41.915 17.6263 42.6089 18.1087 43.1986C18.5912 43.7884 19.2042 44.2577 19.8993 44.5697C20.5945 44.8816 21.3527 45.0274 22.1139 44.9957C23.4041 44.9101 24.612 44.3321 25.4881 43.3811C26.3643 42.4302 26.8416 41.1791 26.8216 39.8863V27.4666L40.7349 22.8981V32.5638C40.0752 32.1813 39.3356 31.9577 38.5745 31.9106C37.8135 31.8636 37.0519 31.9945 36.3502 32.2928C35.6484 32.5912 35.0259 33.0489 34.5317 33.6296C34.0376 34.2104 33.6855 34.8982 33.5033 35.6386C33.3211 36.3791 33.3139 37.1518 33.4821 37.8955C33.6504 38.6392 33.9895 39.3335 34.4727 39.9234C34.9559 40.5133 35.5698 40.9826 36.2658 41.2941C36.9618 41.6056 37.7208 41.7507 38.4826 41.7179C39.772 41.6323 40.9793 41.0548 41.8553 40.1048C42.7314 39.1548 43.2092 37.9047 43.1902 36.6126V15.8187C43.1902 15.6908 43.1603 15.5647 43.1028 15.4505C43.0453 15.3363 42.9619 15.2371 42.8591 15.1609C42.7564 15.0848 42.6373 15.0338 42.5113 15.012C42.3853 14.9902 42.2559 14.9982 42.1336 15.0354L25.5268 20.0901C25.1911 20.1922 24.8971 20.3994 24.6881 20.6813C24.4792 20.9632 24.3663 21.3048 24.3663 21.6557Z"
        fill={secondaryColor}
      />
    </svg>
  );
};

export default TunesIcon;
